var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7 8.5C1.7 4.74446 4.74446 1.7 8.5 1.7C12.2556 1.7 15.3 4.74446 15.3 8.5C15.3 11.9677 12.7044 14.8291 9.35 15.2474V10.2H11.05C11.5195 10.2 11.9 9.81946 11.9 9.35C11.9 8.88055 11.5195 8.5 11.05 8.5H9.35V6.8C9.35 6.33056 9.73055 5.95 10.2 5.95H10.625C11.0945 5.95 11.475 5.56944 11.475 5.1C11.475 4.63056 11.0945 4.25 10.625 4.25H10.2C8.79164 4.25 7.65 5.39168 7.65 6.8L7.65 8.5H5.95C5.48056 8.5 5.1 8.88055 5.1 9.35C5.1 9.81946 5.48056 10.2 5.95 10.2H7.65V15.2474C4.29564 14.8291 1.7 11.9677 1.7 8.5ZM8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z",
    fill: "#103680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.91c524c954c54521ded7af5b36e6fce7.svg";
export { ForwardRef as ReactComponent };